<div class="content" *ngIf="isDataLoaded">
  <div class="container-fluid">
    <div class="page-title clearfix">
      <h1 class="float-left">
        <a href="javascript:void(0);" class="back" (click)="goBack()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        {{'Report' | translate}}
        <small>
          <a [routerLink]="'/help/smart-power-report'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
    </div>
    <div class="page-content">
      <div id="captureSmartReport">
        <section class="user smartReport">
          <div class="top">
            <div class="row red">
              <div class="col-md-6 info">
              <h2 translate>Smart Power Report</h2>
              <p>{{ reportInfo ? reportInfo.reportRang : '-' }}</p>
              
              <p>
                {{ 'Reporting Devices' | translate }}: 
                {{ (reportInfo && reportInfo.onlineDevices != null) ? reportInfo.onlineDevices : '-' }} / 
                {{ (reportInfo && reportInfo.availableDevices != null) ? reportInfo.availableDevices : '-' }} 
                
                ({{'Supported UPS' | translate}})
                <span class="icon" (click)="moreInfo.toggle($event)">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </span>
              </p>
            </div>
              <div class="col-md-6 text-right">
                <h2><span translate>Executive Summary</span></h2>
                <p>{{'Your' | translate}} {{ (reportInfo.type === 0 ? 'Weekly' : 'Monthly') | translate }} {{'insights on power resilience, capacity, and wellness' | translate}}</p>
              </div>
            </div>

          </div>
          <div class="middle relative">
            <div class="info">
              <div #masonryContainer class="relative">

                <!-- UPS Protection Summary -->
                <div class="report-list">
                  <div class="report-status">
                    <div class="flex items-center justify-between">
                      <h5 class="text-uppercase">{{'UPS Protection Summary' | translate}}</h5>
                    </div>

                    <div class="bg-white mt-3">
                      <div class="flex gap-75">
                        <div class="bg-offline-50 rounded-lg p-2 pt-3 pb-3 text-center flex items-center flex-column justify-center">
                          <div class="text-5xl font-bold text-left text-black">{{reportInfo.powerEventsIntercepted === null ? '-' : reportInfo.powerEventsIntercepted}}</div>
                          <div class="text-xs text-gray-600 pr-2 pl-2">{{'Power Threats Blocked by UPS' | translate}}</div>
                        </div>
                        <div class="rounded-lg p-2 pt-3 pb-3 text-center flex items-center flex-column justify-center" [ngClass]="{'bg-critical-50': reportInfo.powerEventDiff > 0, 'bg-normal-50': reportInfo.powerEventDiff <= 0}">
                          <div class="text-2xl font-bold"  [ngClass]="{'text-critical': reportInfo.powerEventDiff > 0, 'text-normal': reportInfo.powerEventDiff <= 0}">{{ reportInfo.powerEventDiff === null ? '-' : (reportInfo.powerEventDiff > 0 ? '+' : '') + reportInfo.powerEventDiff }}</div>
                          <div class="text-xs text-gray-600 pr-2 pl-2">{{'Threats blocked' | translate}}</div>
                          <div class="text-xs">
                            <!-- <span class="font-bold text-black">{{ reportInfo.powerEventPercent > 0 ? '+' : '' }}{{ reportInfo.powerEventPercent | number: '1.0-1' }}</span> -->
                            {{'vs. last' | translate}} {{ (reportInfo.type === 0 ? 'week' : 'month') | translate }} </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- SYSTEM WELLNESS -->
                <div class="report-list">
                  <div class="report-status {{reportInfo.systemWellnessStauts === '-' ? 'undefined': reportInfo.systemWellnessStauts}}">
                    <div class="flex items-center justify-between">
                      <h5 class="text-uppercase">{{'SYSTEM WELLNESS' | translate}}</h5>
                      <!-- <a href="#" class="link" (click)="getDetail(null)">
                        <span class="badge bg-light rounded-pill">
                          <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                      </a> -->
                    </div>

                    <div class="flex gap-4 flex-wrap mt-6">
                      <!-- <div class="icon relative w-20 h-20 flex text-center justify-center">
                        <span class="absolute text-white text-5xl font-bold flex">{{reportInfo.systemWellnessStauts == null ? '-' : (reportInfo.systemWellnessStauts)}}</span>
                      </div> -->
                      <div class="bg-white w-50 rounded-xl p-4 text-center">
                        <p class="text-sm">{{'Time-At-Risk' | translate}}</p>
                        <p class="text-5xl font-bold text-black">{{reportInfo.riskRate == null ? "-" : reportInfo.riskRate}}<span class="text-2xl">%</span></p>
                        <p class="text-xs">({{'Time in Critical or Warning states' | translate}})</p>
                      </div>
                      <div class="bg-white w-50 rounded-xl p-4 text-center">
                        <p class="text-sm">{{'Monitoring Coverage' | translate}}</p>
                        <p class="text-5xl font-bold text-black">
                          <ng-container>
                            {{reportInfo.coverageRate == null ? "-" : reportInfo.coverageRate}}<span class="text-2xl">%</span>
                          </ng-container>
                          <ng-template #noData>-</ng-template>
                        </p>
                        <p class="text-xs">({{'Percentage of time online' | translate}})</p>
                      </div>
                    </div>

                    <!-- <p class="text-sm">
                      <span class="font-bold text-2xl text-black">{{reportInfo.systemStability == null ? "-" : (100 - reportInfo.systemStability)}}% </span>
                      ({{
                        (reportInfo.normalCnt == null || reportInfo.warningCnt == null || reportInfo.offlineCnt == null || reportInfo.criticalCnt == null)
                        ? '-'
                        : ((reportInfo.normalCnt + reportInfo.warningCnt + reportInfo.offlineCnt + reportInfo.criticalCnt) * 5 / 60 | number:'1.2-2')
                      }} {{'hrs' | translate}}) {{'of offline or critical Events(Time without offline or critical events)' | translate}}
                    </p> -->

                    <!-- <div class="bg-white rounded-xl p-4 mt-3">
                      <div class="text-sm mb-2 text-center">{{'Monitoring Coverage' | translate}}</div>
                      <div class="text-5xl font-bold text-center text-black">{{reportInfo.offlineCnt / (reportInfo.normalCnt + reportInfo.warningCnt + reportInfo.offlineCnt + reportInfo.criticalCnt)}}<span class="text-2xl">%</span></div>
                      <p class="text-sm text-center">(Percentage of time online)</p>
                    </div> -->

                    <div class="bg-white mt-3">
                      <div class="flex justify-between items-center mb-2">
                        <span class="text-sm font-bold text-black">{{'Active Alerts' | translate}}</span>
                        <a role="button" tabindex="0" class="link gary" style="cursor: pointer;" (click)="routeToDashboard(); $event.preventDefault()">
                          <span class="badge bg-light rounded-pill">
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                          </span>
                        </a>
                      </div>
                      <div class="flex gap-75">
                        <div class="bg-critical-50 rounded-lg p-2 pt-3 pb-3 text-center">
                          <div class="text-2xl font-bold text-critical">{{reportInfo.criticalCnt == null ? "-" : reportInfo.criticalCnt}}</div>
                          <div class="text-xs text-gray-600">{{'Critical' | translate}}</div>
                        </div>
                        <div class="bg-warning-50 rounded-lg p-2 pt-3 pb-3 text-center">
                          <div class="text-2xl font-bold text-warning">{{reportInfo.warningCnt == null ? "-" : reportInfo.warningCnt}}</div>
                          <div class="text-xs text-gray-600">{{'Warning' | translate}}</div>
                        </div>
                        <div class="bg-offline-50 rounded-lg p-2 pt-3 pb-3 text-center">
                          <div class="text-2xl font-bold text-offline">{{reportInfo.offlineCnt == null ? "-" : reportInfo.offlineCnt}}</div>
                          <div class="text-xs text-gray-600">{{'Offline' | translate}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="chartView" id="systemStabilityChart">
                      <p-chart type="line" [data]="systemStabilityChart" [options]='chartSystemStabilityOption'></p-chart>
                    </div>
                  </div>

                </div>
                <!-- Power Anomaly Insights  -->
                <div class="report-list">
                  <div class="report-status {{reportInfo.powerProtectionStauts === '-' ? 'undefined': reportInfo.powerProtectionStauts}}">
                    <div class="flex items-center justify-between">
                      <h5 class="text-uppercase">{{'Power Anomaly Insights' | translate}}</h5>
                      <a class="link" style="cursor: pointer;" (click)="getDetail(getReportCategoryOption('UPS Protection and Power Anomaly'))">
                        <span class="badge bg-light rounded-pill">
                          <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>

                    <div class="flex items-center gap-4 mb-6 mt-6">
                      <!-- <div class="icon relative w-20 h-20 flex text-center justify-center">
                        <span class="absolute text-white text-5xl font-bold flex text-black">{{ reportInfo.powerProtectionStauts == null ? '-' : (reportInfo.powerProtectionStauts)}}</span>
                      </div> -->
                      <div class="bg-white w-100 rounded-xl p-4">
                        <p class="text-sm text-center">{{'Device With Power Events' | translate}}</p>
                        <p class="text-5xl font-bold text-center text-black">{{reportInfo.affectedDevices == null ? "-" : reportInfo.affectedDevices}}<span class="text-2xl">/{{reportInfo.onlineDevices == null ? "-" : reportInfo.onlineDevices}} {{'reporting unit(s) ' | translate}}</span></p>
                      </div>
                    </div>

                    <div class="bg-white rounded-xl p-4" *ngIf="reportInfo.powerCommunityBenchmark !== null">
                      <div class="text-sm mb-3 text-center">{{'Community' | translate}}<br />{{'Benchmark' | translate}}</div>
                      <div class="relative w-24 h-24 mx-auto">
                        <div class="pie-wrapper">
                          <div class="powerQuality-progress">
                            <div class="text-xs">{{'BUTTOM' | translate}}</div>
                            <div class="label">{{reportInfo.powerCommunityBenchmark == null ? "-" : reportInfo.powerCommunityBenchmark}}<span class="text-xs">%</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="chartView" id="powerProtectionChart">
                      <p-chart type="line" [data]="powerProtectionChart" [options]='chartPowerProtectionOption'></p-chart>
                    </div>
                  </div>
                </div>
                <!-- Estimated Consumption Profile -->
                <div class="report-list">
                  <div class="report-status">
                    <div class="flex items-center justify-between">
                      <h5 class="text-uppercase">{{'Estimated Consumption Profile' | translate}}</h5>
                      <a class="link" style="cursor: pointer;" (click)="getDetail(getReportCategoryOption('Estimated Consumption'))">
                        <span class="badge bg-light rounded-pill">
                          <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>

                    <!-- <div class="flex items-center gap-4 mb-6 mt-6">
                      <div class="icon relative w-20 h-20 flex text-center justify-center">
                        <span class="absolute text-white text-5xl font-bold flex text-black">{{reportInfo.energySavingStauts === 'A+' ? 'A' : reportInfo.energySavingStauts}}</span>
                      </div>
                      <div>
                        <p class="text-sm" *ngIf="reportType == 0 else oneMonth">{{'7-Day Total' | translate}}</p>
                        <ng-template #oneMonth>
                          <p class="text-sm">{{'One-Month Total' | translate}}</p>
                        </ng-template>
                        <p class="text-5xl font-bold text-left text-black">{{reportInfo.energyConsumption == null ? "-" : reportInfo.energyConsumption}}<span class="text-2xl">({{'kwh' | translate}})</span></p>
                        <p class="text-sm font-bold text-left text-normal">{{reportInfo.energyConsumptionDiffPec > 0 ? '+' : '' }}{{reportInfo.energyConsumptionDiffPec | percent:'1.0-2' }} <span>{{'vs last' | translate}} {{ reportInfo.type === 0 ? 'week' : 'month' }}</span></p>
                      </div>
                    </div> -->

                    <div class="bg-white w-100 rounded-xl p-4 mb-3 mt-6">
                      <div class="text-sm mb-3 text-center">{{'Operational Consumption Estimate' | translate}}<br /><span class="text-xs">{{'by average load' | translate}}</span></div>
                      <p class="text-5xl font-bold text-center text-black">{{reportInfo.energyConsumption == null ? "-" : reportInfo.energyConsumption}}<span class="text-2xl"> {{'Est. kWh' | translate}}</span>
                      </p>
                      <!-- <p class="text-sm text-center">
                        <span class="font-bold text-black pr-1">{{reportInfo.energyConsumptionDiffPec > 0 ? '+' : '' }}{{reportInfo.energyConsumptionDiffPec | percent:'1.0-2' }}</span>
                        <span>{{'Est. kWh' | translate}}</span>
                      </p> -->
                    </div>

                    <div class="flex gap-4 flex-wrap">
                      <div class="bg-white w-50 rounded-xl p-4" *ngIf="reportInfo.energyCommunityRank !== null">
                        <div class="text-sm mb-3 text-center">{{'Community' | translate}}<br />{{'Benchmark' | translate}}</div>
                        <div class="pie-wrapper">
                          <div class="energySaving-progress">
                            <div class="text-xs">{{'TOP' | translate}}</div>
                            <div class="label">{{reportInfo.energyCommunityRank == null ? "-" : reportInfo.energyCommunityRank}}<span class="text-xs">%</span></div>
                          </div>
                        </div>
                      </div>

                      <div class="bg-white w-50 rounded-xl p-4">
                        <div class="text-sm mb-3 text-center">{{ (reportInfo.type === 0 ? 'Weekly' : 'Monthly') | translate }} {{'Trend' | translate}}</div>
                        <div class="text-center">
                          <div class="text-3xl font-bold text-center text-black">{{ reportInfo.energyConsumptionDiff > 0 ? '+' : '' }} {{reportInfo.energyConsumptionDiff == null ? "-" : reportInfo.energyConsumptionDiff}}
                            <p class="text-sm text-center">
                              <span class="text-1xl"> {{'Est. kWh' | translate}}</span>
                            </p>
                          </div>
                          <p class="text-sm text-center">
                            <span class="font-bold text-black pr-1">{{ reportInfo.energyConsumptionDiffPec > 0 ? '+' : '' }} ({{reportInfo.energyConsumptionDiffPec === null ? '-' : reportInfo.energyConsumptionDiffPec}} %)</span>
                            <!-- <span>{{'Est. kWh' | translate}}</span> -->
                          </p>
                          <div class="flex text-center justify-center gap-1 text-green-500 text-sm mt-2">
                            <span>{{'vs. last' | translate}} {{ (reportInfo.type === 0 ? 'week' : 'month') | translate }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="bg-white rounded-xl p-4 flex flex-column justify-content-center" 
                      [ngClass]="{'w-100': reportInfo.energyCommunityRank !== null, 'w-50': reportInfo.energyCommunityRank === null}">
                        <div class="text-sm mb-2 text-center">{{'Carbon Footprint' | translate}}</div>
                        <div class="text-3xl font-bold text-center text-normal">{{reportInfo.energyCO2e == null ? "-" : reportInfo.energyCO2e}}<span class="text-1xl text-normal">{{'kg' | translate}} CO<sub>2</sub>e</span></div>
                        <!-- <div class="text-sm mb-2 text-center mt-2">
                          <p>🌲 {{'Equivalent to planting' | translate}}</p>
                          <p><span class="font-bold">{{reportInfo.energyTrees == null ? "-" : reportInfo.energyTrees}} </span>{{'trees' | translate}}</p>
                        </div> -->
                      </div>
                    </div>
                    <div class="chartView" id="energySavingChart">
                      <p-chart type="line" [data]="energySavingChart" [options]='chartEnergySavingOption'></p-chart>
                    </div>
                    <div class="flex">
                      <div class="bg-offline-50 p-3 text-xs">
                        {{'Note: Operational Consumption figures are estimated based on average load data and exclude device offline periods. These values may differ from actual billing and are provided for reference and trend analysis only.' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- LOAD DISTRIBUTION -->
                <div class="report-list">
                  <div class="report-status {{reportInfo.loadDistributionStauts === '-' ? 'undefined': reportInfo.loadDistributionStauts}}">
                    <div class="flex items-center justify-between">
                      <h5 class="text-uppercase">{{'LOAD DISTRIBUTION' | translate}}</h5>
                      <a role="button" tabindex="0" class="link" style="cursor: pointer;" (click)="getDetail(getReportCategoryOption('Load Distribution')); $event.preventDefault()">
                        <span class="badge bg-light rounded-pill">
                          <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                      </a>
                    </div>

                    <!-- <div class="flex items-center gap-4 mb-6 mt-6">
                      <div class="icon relative w-20 h-20 flex text-center justify-center">
                        <span class="absolute text-white text-5xl font-bold flex text-black">{{ reportInfo.loadDistributionStauts == null ? '-' : (reportInfo.loadDistributionStauts)}}</span>
                      </div>
                    </div> -->
                    <div class="flex gap-4 flex-wrap mt-6">
                      <div class="bg-white w-100 rounded-xl p-4">
                        <div class="text-sm mb-2 text-center">{{'Load Approaching Peak Capacity' | translate}}</div>
                        <div class="text-5xl font-bold text-center text-black">{{reportInfo.loadDistribution == null ? "-" : reportInfo.loadDistribution}}<span class="text-2xl">/{{reportInfo.onlineDevices == null ? "-" : reportInfo.onlineDevices}} {{'reporting unit(s) ' | translate}}</span></div>
                      </div>
                      <div class="bg-white w-100 rounded-xl p-4">
                        <div class="text-sm mb-2 text-center">{{'Fleet Utilization' | translate}}</div>
                        <ng-container *ngIf="reportInfo.totalAvgLoad != null">
                          <div class="text-2xl font-bold text-center text-normal" *ngIf="reportInfo.totalAvgLoad < 40">
                            {{ 'Base' | translate }}
                          </div>
                          
                          <div class="text-2xl font-bold text-center text-warning" *ngIf="reportInfo.totalAvgLoad >= 40 && reportInfo.totalAvgLoad < 70">
                            {{ 'Mid' | translate }} </div>
                          
                          <div class="text-2xl font-bold text-center text-critical" *ngIf="reportInfo.totalAvgLoad >= 70">
                            {{ 'High' | translate }}
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="chartView" id="loadDistributionChart">
                      <p-chart type="bar" [data]="loadDistributionChart" [options]='chartLoadOption' [plugins]="chartPlugins"></p-chart>
                      <!-- <span class="title flex justify-center">Avg. Load</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
<p-popover #moreInfo class="infoPanel batteryHealth" styleClass="infoPanel">
  <div class="infoPanel">
    <p translate>The 'Reporting' count includes only connected single-phase UPS units. 3-Phase UPS, ATS, PDUs, and completely offline devices are excluded from the supported total to ensure data accuracy.</p>
  </div>
</p-popover>